import Client from "shopify-buy"

const shopify = Client.buildClient({
  domain: "panther-atirer.myshopify.com",
  storefrontAccessToken: "e41beda8ec5ff3e6796d409fb7f1d7f8"
})

export default shopify
